import React from "react";
import { motion } from "framer-motion";
import serviceLanding from "../assets/serviceLanding.webp";

function LandingService() {
  const easing = [0.6, -0.05, 0.01, 0.99]; // Custom cubic-bezier easing

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 1, delay: i * 0.3, ease: easing },
    }),
  };

  return (
    <div
      className="relative mt-[80px] h-[400px] w-full bg-cover bg-center"
      style={{ backgroundImage: `url(${serviceLanding})` }}
    >
      {/* Background Overlay */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-t from-white/60 to-white/30 z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      ></motion.div>

      {/* Content container */}
      <div className="relative z-20 flex items-center justify-center w-full h-full">
        <motion.div
          className=" flex justify-center items-center slg:ml-14 lg:px-8 lg:max-w-[500px] px-8 max-w-[320px] text-customAqua600"
          initial="hidden"
          animate="visible"
          variants={textVariants}
          custom={0}
        >
          <motion.p
            className="lg:text-5xl lg:mb-4 text-3xl mb-4 font-semibold"
            variants={textVariants}
            custom={0}
          >
            Nos Services
          </motion.p>
          
         
        </motion.div>
      </div>
    </div>
  );
}

export default LandingService;
